import type { MaintenanceRequestStatus } from '../../core/Types';

export const VENDOR_OPTIONS = [
  'Fisher Plumbing',
  'Evergreen HVAC',
  'Bright Electric',
];

type StatusOption = {
  value: Extract<MaintenanceRequestStatus, 'new' | 'inProgress'>;
  label: string;
};

export const STATUS_OPTIONS: StatusOption[] = [
  { value: 'new', label: 'Pending' },
  { value: 'inProgress', label: 'In Progress' },
];
